export enum AppSideActionType {
  DRAWER = 'drawer', // 右侧弹窗
  EVENT = 'event', // 事件
  CUSTOM = 'custom' // 自定义
}
